//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Card from './_card'
import Stars from '@/common/tpl/value_analysis/_stars'
export default {
    mixins: [],
    props: {
        plate: Object,
        ratings: Array
    },
    components: {
        Stars,
        Card
    },
    watch: {
    },
    methods: {
        goPlate (id) {
            wx.navigateTo({
                url: `/packageB/plates/main?id=${id}`
            })
        }
    }
}
